import React from 'react';
import Form from 'react-bootstrap/Form';
import { LinkButton } from 'common';
import 'pages/styles/commonPage.scss';

const Success = ({ header, href, buttonText }) => (
  <div className="occu-form">
    <h5>{header}</h5>
    <Form>
      <LinkButton href={href}>{buttonText || 'Login'}</LinkButton>
    </Form>
  </div>
);

export { Success };
